var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    { attrs: { label: _vm.label } },
    [
      _c(
        "v-select",
        {
          class: { "v-select-danger": _vm.danger, "select-size-sm": _vm.small },
          attrs: {
            label: "name",
            name: _vm.name,
            value: _vm.optionSelected,
            options: _vm.paginatedValues,
            disabled: _vm.isDisabled,
            filterable: false,
            clearable: _vm.isClearable,
            placeholder: _vm.placeholder
          },
          on: {
            search: _vm.onSearch,
            input: _vm.onInput,
            "search:focus": _vm.onFocus,
            close: _vm.onClose
          },
          scopedSlots: _vm._u([
            {
              key: "spinner",
              fn: function() {
                return [
                  _c("b-spinner", {
                    style: { opacity: _vm.aprovalsState.loading ? 1 : 0 },
                    attrs: { small: "", variant: "primary" }
                  })
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("template", { slot: "no-options" }, [
            _vm._v(" escribe para buscar aprobaciones.. ")
          ]),
          _vm.hasNextPage
            ? _c(
                "li",
                {
                  staticClass: "pagination",
                  attrs: { slot: "list-footer" },
                  slot: "list-footer"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block btn-primary btn-sm",
                      attrs: { type: "button", disabled: !_vm.hasNextPage },
                      on: { click: _vm.searchPage }
                    },
                    [_vm._v(" buscar mas aprobaciones... ")]
                  )
                ]
              )
            : _vm._e()
        ],
        2
      ),
      _vm.danger
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger v-enter-to",
              staticStyle: { height: "19px" }
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.dangerText) + " ")
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }